<script setup lang="ts">
import type { IBadge } from '../../models/badge';

import ProductFloatingCap from './ProductFloatingCap.vue';
import CallToAction from '../common/CallToAction.vue';

import { computed, ref } from 'vue';
import { useProductPage } from '../../business/use-product-page';
import type { IProduct } from '../../models/product';
import type { IBanner } from '../../models/banner';

const { state, getProductBadges } = useProductPage();

const badges = computed<IBadge[]>(() => {
  if (!state.product) return [];
  const discountBadge = state.currentSku?.discountBadge;
  const productBadges = getProductBadges(state.product as IProduct);

  return [
    ...(discountBadge
      ? ([
          {
            id: -9,
            label: discountBadge.text,
            backgroundColor: discountBadge.backgroundColor,
            color: discountBadge.textColor,
          },
        ] as IBadge[])
      : []),
    ...productBadges,
  ];
});

const isFloatingCupShown = ref(false);
</script>

<template>
  <div class="product-cta">
    <ProductFloatingCap :is-shown="isFloatingCupShown" />

    <CallToAction
      :sellPrice="state.currentSku?.purchasePrice || 0"
      :fullPrice="state.currentSku?.fullPrice || 0"
      :badges="badges"
      :installments="
        state.currentSku?.productOptionDtos?.map((item) => ({
          name: item.type,
          label: item.text,
        })) || []
      "
      :availableAmount="state.currentSku?.availableAmount || 0"
      :isOneClickShown="true"
      :banners="(state.banners || []) as IBanner[]"
      :discount-timer="state.currentSku?.discountTimer || undefined"
      @onChangeAddButtonVisibility="(value) => (isFloatingCupShown = !value)"
      class="product-cta__content"
    />
  </div>
</template>

<style lang="stylus" scoped>
.product-cta
  align-self start
  height 100%
  min-width 397px

  &__content
    position sticky
    top 24px
</style>
